import { render } from "./EditMetricGroup.vue?vue&type=template&id=7bb60516"
import script from "./EditMetricGroup.vue?vue&type=script&lang=js"
export * from "./EditMetricGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__